export default {
    state: {
        title: ''
    },

    getters: {
        pageTitle(state) {
            return state.title;
        }
    },

    mutations: {
        setPageTitle(state, payload) {
            state.title = payload;
        }
    },

    actions: {
        setPageTitle({ commit }, payload) {
            return commit('setPageTitle', payload);
        }
    }
};
